import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Box,
  Typography,
  IconButton,
  Divider,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import useSession from "src/Hooks/useSession";
import { useNavigate } from "react-router-dom";

function MealDealDialog() {
  const navigate = useNavigate();
  const {
    dispatch,
    show_meal_deal_dialog,
    sessionDetails: { restaurant },
  } = useSession();

  const handleOptionSelect = (option) => {
    if (option === "MEAL") {
      dispatch({ type: "MEAL_DEAL_ADDED" });
      if (!show_meal_deal_dialog?.item?.is_addon_available) {
        navigate("menu/addMealDeal");
        dispatch({ type: "CLOSE_MEAL_DEAL_DIALOG" });
      } else {
        show_meal_deal_dialog?.onOptionSelect?.(option);
        dispatch({ type: "CLOSE_MEAL_DEAL_DIALOG" });
      }
    } else {
      show_meal_deal_dialog?.onOptionSelect?.(option);
      dispatch({ type: "CLOSE_MEAL_DEAL_DIALOG" });
    }
  };
  return (
    <>
      <Dialog
        open={show_meal_deal_dialog?.open || false}
        onClose={() => dispatch({ type: "CLOSE_MEAL_DEAL_DIALOG" })}
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: { xs: "95%", sm: "80%", md: "30%", lg: "40%" },
            borderRadius: "12px",
            m: 1,
          },
        }}
      >
        <DialogTitle>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" textAlign="center">
              Do you want to make this a Meal
            </Typography>
            <IconButton
              onClick={() => dispatch({ type: "CLOSE_MEAL_DEAL_DIALOG" })}
            >
              <CancelIcon />
            </IconButton>
          </Stack>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={{ xs: 2, sm: 3 }}
          >
            <Stack
              sx={{
                cursor: "pointer",
                width: { xs: "60%", sm: "180px" }, // responsive width
                borderRadius: "10px",
                bgcolor: "#ffffff",
                boxShadow: "2px 2px 12px 8px rgba(99,94,94,0.37)",
                pt: 2,
                justifyContent: "space-between",
                mb: { xs: 2, sm: 0 }, // margin bottom for vertical stacking
              }}
              onClick={() => handleOptionSelect("MEAL")}
            >
              <Typography align="center">Make it a Meal</Typography>
              <Box p={2} pt={1}>
                <img
                  style={{
                    borderRadius: "8px",
                    width: "100%",
                    height: "180px",
                  }}
                  src={
                    restaurant?.make_it_a_meal_image ||
                    "/assets/images/make_it_a_meal.png"
                  }
                  alt="Make it a Meal"
                />
              </Box>
            </Stack>

            <Stack
              sx={{
                cursor: "pointer",
                width: { xs: "60%", sm: "180px" },
                borderRadius: "10px",
                bgcolor: "#ffffff",
                boxShadow: "2px 2px 12px 8px rgba(99,94,94,0.37)",
                pt: 2,
                justifyContent: "space-between",
              }}
              onClick={() => handleOptionSelect("ITEM_ONLY")}
            >
              <Typography align="center">Item Only</Typography>
              <Box p={2} pt={1}>
                <img
                  style={{
                    borderRadius: "8px",
                    width: "100%",
                    height: "180px",
                  }}
                  src={
                    show_meal_deal_dialog?.item?.item_image ||
                    "/assets/images/item_only.png"
                  }
                  alt="Order Only"
                />
              </Box>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default MealDealDialog;
